import { MissionData } from '../blocks/mission'
import template from './templates/RJF10.rbxl'
import thumbnail1 from './thumbnails/RJF10/RedBlock.png'
import thumbnail2 from './thumbnails/RJF10/YellowBlock.png'
import thumbnail3 from './thumbnails/RJF10/SpawnLocation.png'

const mission: MissionData = {
  // Set the template and other metadata.
  // テンプレートとその他のメタデータを設定します。
  number: 2,
  stage: 0,
  thumbnail: '',
  title: '',
  template,
  chapters: [{}, {}, {}, {}, {}],
  objects: [
    {
      name: '①あかいブロック',
      thumbnail: thumbnail1,
    },
    {
      name: '②きいろいブロック',
      thumbnail: thumbnail2,
    },
    {
      name: '③スタートちてん',
      thumbnail: thumbnail3,
    },
  ],
}

export default mission
